import { render, staticRenderFns } from "./control-tab-content.vue?vue&type=template&id=5a13fe0c"
import script from "./control-tab-content.vue?vue&type=script&lang=ts"
export * from "./control-tab-content.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports